import { ICustomerCardsRepository } from 'modules/customer/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import VectisCustomerCardsRepository from './implementations/VectisCustomerCardsRepository';

let instance: ICustomerCardsRepository | null = null;

export default function makeCustomerCardsRepository() {
  if (!instance) {
    const httpProvider = makeHTTPProvider();

    instance = new VectisCustomerCardsRepository(httpProvider);
  }

  return instance;
}
